<div class="reset" (click)="openFileInput()" (mouseenter)="show=1" (mouseleave)="show=0" [class.disabler]="!state">
  <img class="viszeek-icon"src="/icons/camera.png" alt="camerIcon">
  <input type="file" accept=".jpg, image/*" #fileInput hidden (change)="onFileSelected($event)">
  @if (show==1) {
    <div>
      <div class="tooltip-Ui">{{"common.vizseek_tooltip" | cxTranslate}}</div>
    </div>
  }
</div>